(function () {
  if (window.elvaraGoogle) return;

  const storageKey = "elvara_google_conversions_v1";
  const sendTo = "AW-18470236183/KEDOCOXp34cdEJfgpedE";
  const totals = Object.freeze({
    "49065432252601": 214,
    "49070438940857": 299,
    "49143789519033": 199,
    "49207485890745": 299,
    "49143797678265": 349,
  });

  function read() {
    const saved = window.localStorage.getItem(storageKey);
    if (!saved) return { version: 1, requestIds: [] };
    const state = JSON.parse(saved);
    if (
      state.version !== 1 ||
      !Array.isArray(state.requestIds) ||
      state.requestIds.length > 2000 ||
      state.requestIds.some(id => !/^[a-zA-Z0-9_-]{16,128}$/.test(id))
    ) {
      throw new Error("invalid_google_conversion_storage");
    }
    return state;
  }

  function save(state) {
    const serialized = JSON.stringify(state);
    window.localStorage.setItem(storageKey, serialized);
    if (window.localStorage.getItem(storageKey) !== serialized) {
      throw new Error("google_conversion_storage_unavailable");
    }
  }

  function purchase(requestId, variantId) {
    const transactionId = String(requestId || "");
    const value = totals[String(variantId)];
    if (!/^[a-zA-Z0-9_-]{16,128}$/.test(transactionId) || value === undefined) return false;
    if (typeof window.gtag !== "function") return false;

    try {
      const state = read();
      if (state.requestIds.includes(transactionId)) return false;
      state.requestIds.push(transactionId);
      save(state);

      window.gtag("event", "conversion", {
        send_to: sendTo,
        value,
        currency: "MAD",
        transaction_id: transactionId,
      });
      return true;
    } catch (_error) {
      return false;
    }
  }

  window.elvaraGoogle = Object.freeze({ purchase });
})();
